import { render, staticRenderFns } from "./ejectionForm.vue?vue&type=template&id=337b6316&scoped=true"
import script from "./ejectionForm.vue?vue&type=script&lang=js"
export * from "./ejectionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337b6316",
  null
  
)

export default component.exports